import React, {FC} from 'react';
import {Drop} from '../../../../grpc_client/grips/protos/shared/drop';
import {useDropsTranslationContext} from '../../../../pages/Drops/context/TranslationProvider';
import {SectionTrackingContextProvider} from '../../../../tracking/context/SectionTrackingContext';
import {
  SectionSeparator,
  SeparatorCategory,
  SeparatorTitle,
  TeaserContainer,
} from '../DropOverviewStyles';
import DropTeaser from '../Teaser/Teaser';

export const PastDrops: FC<{
  pastDrops: Drop[];
}> = ({pastDrops}) => {
  const translations = useDropsTranslationContext();

  if (pastDrops.length === 0) {
    return null;
  }

  return (
    <SectionTrackingContextProvider>
      <SectionSeparator>
        <SeparatorCategory>
          {translations.overview.sections.past.subHeadline}
        </SeparatorCategory>
        <SeparatorTitle>
          {translations.overview.sections.past.headline}
        </SeparatorTitle>
      </SectionSeparator>
      <TeaserContainer>
        {pastDrops.map(drop => (
          <DropTeaser key={drop.id} isMissedDrop drop={drop} />
        ))}
      </TeaserContainer>
    </SectionTrackingContextProvider>
  );
};
